import type { Theme } from '@emotion/react'
import { css } from '@emotion/react'

import { breakpoint, size } from '@twisto/styles'

export const primaryNavigationSlot = (theme: Theme) => css`
  display: none;

  ${breakpoint.up('lg')} {
    display: flex;
    gap: clamp(${size[16]}, 1.5vw + ${size[8]}, ${size[32]});
    margin: 0;
    padding: 0;

    & > * {
      min-width: max-content;
    }

    &::-webkit-scrollbar {
      width: ${size[8]};
      height: ${size[8]};
      background-color: transparent;
    }
    &::-webkit-scrollbar-thumb {
      border-radius: ${size[12]};
      background-color: ${theme.palette.neutral[300]};
      border: 1px solid ${theme.palette.background.primary};
    }
  }
`
